import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Star, Moon, Sparkles } from 'lucide-react';
const TarotCardMinimal = ({
  size = 20,
  className = ''
}) => <svg width={size} height={size * 1.5} viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-248">
    <rect x="1" y="1" width="38" height="58" rx="4" stroke="currentColor" strokeWidth="1.5" data-id="element-249" />
    <circle cx="20" cy="20" r="6" stroke="currentColor" strokeWidth="1" data-id="element-250" />
    <path d="M20 10V30M10 20H30" stroke="currentColor" strokeWidth="1" data-id="element-251" />
    <path d="M12 45L20 37L28 45" stroke="currentColor" strokeWidth="1" data-id="element-252" />
  </svg>;
export function MagicalBackground() {
  const elements = useMemo(() => {
    const types = [Star, Moon, Sparkles, TarotCardMinimal];
    return Array.from({
      length: 25
    }).map((_, i) => ({
      id: i,
      Type: types[i % types.length],
      left: `${Math.random() * 100}%`,
      size: Math.random() * 15 + 10,
      duration: Math.random() * 40 + 40,
      delay: Math.random() * -40,
      opacity: Math.random() * 0.15 + 0.05,
      rotate: Math.random() * 360
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-253">
      {/* Background elements */}
      {elements.map(({
      id,
      Type,
      left,
      size,
      duration,
      delay,
      opacity,
      rotate
    }) => <motion.div key={id} style={{
      position: 'absolute',
      left,
      width: size,
      height: size,
      color: id % 2 === 0 ? '#d4af37' : '#9333ea',
      opacity
    }} initial={{
      y: '110vh',
      rotate
    }} animate={{
      y: '-10vh',
      rotate: rotate + 360,
      x: [0, Math.random() * 50 - 25, 0]
    }} transition={{
      duration,
      repeat: Infinity,
      delay,
      ease: 'linear'
    }} data-id="element-254">
            <Type size={size} data-id="element-255" />
          </motion.div>)}
    </div>;
}